import axios from '@/services'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from './auth'
import { useLookupsStore } from './lookups'

/**
 * this is a module specific store.
 * related services that might use this store:
 * so yeah similar to an angular controller
 *
 * familyBookAddWifeOrHusband
 * issueFirstFamilyBook
 * guardianshipFileCancellation
 * naturalizationRequest
 * femaleChildrenNaturalizationRequest
 * citizenWifeNaturalizationRequest
 * removePersonDueToDivorce
 * familyBookAddChild
 * maritalStatusModification
 * citizenMothersNameModification
 * citizenBirthdateModification
 * citizenAgeEstimation
 * citizenFirstNameModification
 * citizenAddingAnExistingNickname
 * issueFamilyBookInReplaceOrDamage
 * familyBookSeparateRegistrationAfter30
 * familyBookReplacement
 * guardianship
 * issueNewFamilyBookDueDivorcing
 */

export const useFamilyBookStore = defineStore('familyBook', () => {
  const members = ref([])

  const getFamilyBookMembers = async (searchCriteria = {}) => {
    members.value = await axios.post('/api/individual/citizen/getFamilyBookMembers', searchCriteria)
  }

  const state = {
    members
  }

  const actions = {
    getFamilyBookMembers
  }

  return { ...state, ...actions }
})
